var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"devlog-header"},[_c('h1',{attrs:{"id":"github-link"},on:{"click":_vm.openGithub}},[_vm._v("Gregory Kogan's")]),_c('h2',[_vm._v("⌨️ Devlog")])])
}
var staticRenderFns = []

export { render, staticRenderFns }